<script setup lang="ts">
import {type InferType, object, string} from "yup";
import type {FormSubmitEvent} from "@nuxt/ui";
import {useAuthStore} from "~~/stores/auth";

const { t } = useI18n()
const auth = useAuthStore()
const toast = useToast()

const emit = defineEmits<{
    (e: 'success'): void
}>()

const schema = object({
    email: string().email(t('partials.form.emailInvalid')).required(t('partials.form.required')),
})

type Schema = InferType<typeof schema>

const state = reactive({
    email: ''
})

async function onForgottenPasswordSubmit(payload: FormSubmitEvent<Schema>) {
    try {
        await auth.forgottenPassword(payload.data)
        toast.add({
            title: t('userProfile.login.forgottenPasswordEmailSent'),
            color: 'success'
        })
        emit('success')
    } catch (error: any) {
        toast.add({
            title: t('userProfile.login.forgottenPasswordError'),
            description: error?.data?.message
                || error?.data?.errors?.email?.[0]
                || error?.data?.errors?.password?.[0]
                || error?.message
                || t('userProfile.login.forgottenPasswordErrorDescription'),
            color: 'error'
        })
    }
}
</script>

<template>
    <div>
        <UForm :schema="schema" :state="state" class="space-y-8 z-1 w-full" @submit="onForgottenPasswordSubmit">
            <div class="flex flex-col gap-4">
                <UFormField label="Elektronski naslov" name="email" class="flex-1">
                    <UInput v-model="state.email" :placeholder="t('userProfile.login.email')" class="w-full"/>
                </UFormField>
                <UButton type="submit" class="w-fit">{{ t('userProfile.login.forgottenPasswordSendEmail') }}</UButton>
            </div>
        </UForm>
    </div>
</template>

<style scoped>

</style>
